import React from 'react';
import { Progressbar as ProgressbarOriginal } from '@fiverr-private/fit';

export const ProgressBar = (props) => <ProgressbarOriginal {...props}/>;
